import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from './providers';
import AppRoutes from './routes/app';

function App() {
  return (
    <>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
